import React, { Component } from 'react';
import Cookies from "universal-cookie";
import styled from 'styled-components';
import './addressplan.css'
import {Host} from '../../../config/config'

const Addressplanwindow = styled.div`

  position: absolute;
  top:1px;
  left: 1px;
  width:100%;
   height: 74vh;
  overflow-y: scroll;
  background: #e5e5f5;
`

class Addressplan extends Component {

  constructor(props){
    super(props)
    this.close=this.close.bind(this)
    this.editplan=this.editplan.bind(this)
    this.doedit = this.doedit.bind(this);

    this.state  = {
      isFetching:true,
      addr:null,
      ep:'',
      description:'',
      value:'',
      cookies :  new Cookies()
    }
  }


fetcher(){



}

componentDidMount(){

     fetch('http://'+Host+'/api/ocnitcustomerinfo/',

        {
            method: 'POST',
            headers: new Headers({
                     'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
                     // 'Access-Control-Allow-Origin': '*',
            }),

            body: "author="+this.state.cookies.get('sidd')+"&section=edit_customer_info&com=get_addr_plan&mode=get_addr_plan&nets="+this.props.nets // <-- Post parameters

        }
      )

        .then((response)=>response.json())
    //      .then((nets)=>this.setState({cnet:nets[0]['net']}))
          .then((plan)=>this.setState({addr:plan, isFetching:false}, ()=>console.log(this.state.addr)))


}

editplan( id, description){
    this.setState({ep:id, description:description})
}

close(){
  this.props.addressplanwindow('off')
}


doedit(host, description, ip, nets){

  this.setState({fetched:false})

      fetch('http://'+Host+'/api/ocnitcustomerinfo/',

        {
      method: 'POST',
      headers: new Headers({
               'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
               // 'Access-Control-Allow-Origin': '*',
      }),


      body: "author="+this.state.cookies.get('sidd')+"&section=edit_customer_info&com=edit_plan_addr&ip="+ip+"&description="+description+"&nets="+nets // <-- Post parameters

        }    )
        .then((response)=>response.json())

          .then((plan)=>this.setState({addr:plan,ep:null}))

}




  render() {

    return (
      <Addressplanwindow >
      <div style={{'text-align':'right', 'cursor':'pointer'}}><a href={null} onClick={this.props.closenetwin}>(Назад к списку сетей)</a></div>
      <div className='netheader'> Сеть: {this.props.nets} </div>

      {this.state.addr ?
        <div className="">
        <table  align="center" >
          <tbody>
            <tr className='tableheader'>
                <td>
                    IP
                </td>
                <td>
                    Описание
                </td>
                <td>
                    Запись DNS
                </td>

            </tr>
        {this.state.addr.map((addrs)=>
         <tr key={addrs.id} className="tablelist">



            <td>{addrs.ip} -</td>
              { this.state.ep === addrs.id ?
                  <td>
                       <input type="text" value={this.state.description} onChange={(e) => this.setState({description: e.target.value})} />
                       <button onClick={()=>this.doedit(this.props.host, this.state.description, addrs.ip, this.props.nets)}>Ok</button>
                  </td>
                  :
                  <td>
                    {addrs.description} 	<a href={null} onClick={()=>this.editplan(addrs.id, addrs.description)} className="cursor">&#9998;</a>
                 </td>
              }
            <td>
                Временно недоступно
            </td>
         </tr>


       )}
     </tbody>
         </table>
          </div>
        :
          <div>{this.state.isFetching ? 'Загружаем': 'Данных не найдено'}</div>

      }



    </Addressplanwindow>
    );
  }

}
export default Addressplan;
